import React from "react";
import { WithLazy } from "@quintype/components";

import HoroscopeGrid from "../../molecules/horoscope-grid";
import { AdContainer } from "../../ads";

import "./horoscope-collection.m.css";

const HoroscopeCollection = ({ collection }) => {
  return (
    <WithLazy>
      {() => (
        <div styleName="wrapper">
          <div styleName="horoscope-wrapper">
            <h1 styleName="collection-name">{collection.name}</h1>
            <div styleName="content">
              <div styleName="text">
                ನಿಮ್ಮ ರಾಶಿ ಭವಿಷ್ಯ ಗ್ರಹ-ಗತಿಗಳ ಚಲನೆಯ ಪ್ರಕಾರ ಗಣನೆ ಮಾಡಲಾಗುವ ಜ್ಯೋತಿಷ ಶಾಸ್ತ್ರದ ಆಧಾರದಲ್ಲಿ ಹನ್ನೆರಡು ರಾಶಿಗಳ
                ಭವಿಷ್ಯ ಹೇಗಿದೆ? ಇಂದಿನ ಭವಿಷ್ಯದ ಜೊತೆಗೆ ವಾರಭವಿಷ್ಯ, ಮಾಸ ಭವಿಷ್ಯ ಹಾಗೂ ವರ್ಷ ಭವಿಷ್ಯ ತಿಳಿಯಿರಿ!
              </div>
              <HoroscopeGrid />
            </div>
          </div>
          <div styleName="ad-wrapper" className="hide-mobile">
            <AdContainer AdClassName="standard-300x250" id="div-gpt-ad-1675837026472-0" desktop="PV_Desktop_HP_RM" />
          </div>
        </div>
      )}
    </WithLazy>
  );
};

export default HoroscopeCollection;
